/**
 * The page zoom set on the root (the app scales up on big monitors). Browsers report element
 * rectangles in screen pixels but place fixed elements in zoomed pixels, so a popup placed from a
 * rectangle divides by this to land where it should.
 */
export function pageZoom(): number {
  const z = Number.parseFloat(getComputedStyle(document.documentElement).zoom);
  return Number.isFinite(z) && z > 0 ? z : 1;
}
